import { render, staticRenderFns } from "./manageExamQuestionsItem.vue?vue&type=template&id=db77de9e"
import script from "./manageExamQuestionsItem.vue?vue&type=script&lang=js"
export * from "./manageExamQuestionsItem.vue?vue&type=script&lang=js"
import style0 from "./manageExamQuestionsItem.vue?vue&type=style&index=0&id=db77de9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports